/* eslint-disable no-useless-catch */
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import styled from 'styled-components';

import { importIcons } from '@powdr/utils';

const StyledIcon = styled.div`
  position: relative;
  isolation: isolate;
  width: ${({ width }) => (width ? `${(width === 'fit-content') ? `${width}` : `${width}px`}` : 'auto')};
  height: ${({ height }) => (height ? `${(height === 'fit-content') ? `${height}` : `${height}px`}` : 'auto')};
  min-width: ${({ width }) => (width ? `${(width === 'fit-content') ? `${width}` : `${width}px`}` : '')};

  svg {
    fill: ${({ color }) => color ?? 'white'};
    color: ${({ color }) => color ?? 'white'};
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const Icon = ({
  className = '',
  width = null,
  height = null,
  color = null,
  name = 'unknown',
  autoplay = true,
  loop = true,
  speed = 1,
  lottieThemeId = null,
  lottieThemeData = null,
  lottieTint = false,
}) => {
  const icons = { ...importIcons(require.context('./icons', true, /\.svg$/)) };
  const lottieContext = require.context('./lotties', true, /\.(lottie|json)$/);
  const lotties = lottieContext.keys().reduce((acc, key) => {
    const fileName = key.split('/').pop() || '';
    const lottieName = fileName.replace(/\.(lottie|json)$/, '');
    acc[lottieName] = lottieContext(key);
    return acc;
  }, {});
  const IconComponent = icons?.[name] || null;
  const lottieSrc = lotties?.[name]?.default || lotties?.[name] || null;

  if (!IconComponent && !lottieSrc) return null;

  const elementRef = useRef();

  return (
    <StyledIcon
      className={className}
      color={color}
      width={width}
      height={height}
      $isLottie={!IconComponent && Boolean(lottieSrc)}
      $lottieTint={lottieTint}
      ref={elementRef}
    >
      {IconComponent ? (
        <IconComponent />
      ) : (
        <DotLottieReact
          src={lottieSrc}
          loop={loop}
          autoplay={autoplay}
          speed={speed}
          themeId={lottieThemeId}
          themeData={lottieThemeData}
          renderConfig={{ autoResize: true }}
        />
      )}
    </StyledIcon>
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  speed: PropTypes.number,
  lottieThemeId: PropTypes.string,
  lottieThemeData: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  lottieTint: PropTypes.bool,
};
